module.exports = __webpack_public_path__ + "static/img/img.1577f1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/android/img.png
// module id = jumG
// module chunks = 0